import Ajax from './Ajax.js'

const Additionality = {
  getAdditionalities: (id = null) => {
    let uri = id !== null
      ? '/additionalities' + '/' + id
      : '/additionalities'
    return Ajax.get(uri)
  },

  postAdditionalities: (params) => {
    const payload = params && params.data ? params : {
      data: {
        priority: params.priority !== undefined ? Number(params.priority) : 0,
        type: params.type,
        additionalityType: params.additionalityType || params.additionality_type,
        treeType: params.treeType || params.tree_type,
        area: params.area,
        startingDt: params.startingDt || params.starting_dt,
        startingYear: params.startingYear !== undefined ? parseInt(params.startingYear) : (params.starting_year !== undefined ? parseInt(params.starting_year) : undefined),
        endYear: params.endYear !== undefined ? parseInt(params.endYear) : (params.end_year !== undefined ? parseInt(params.end_year) : undefined),
        values: (params.values || []).map(v => ({
          year: v.year !== undefined ? parseInt(v.year) : undefined,
          value: v.value !== undefined ? parseFloat(v.value) : undefined,
          baselineValue: v.baselineValue !== undefined ? parseFloat(v.baselineValue) : (v.baseline_value !== undefined ? parseFloat(v.baseline_value) : undefined)
        }))
      }
    }
    return Ajax.post('/additionalities', payload)
  },

  putAdditionalities: (params) => {
    const id = params.id
    const data = { ...params }
    delete data.id
    const payload = params && params.data ? params : { data }
    return Ajax.put('/additionalities/' + id, payload)
  },

  delAdditionalities: (id) => {
    return Ajax.delete('/additionalities/' + id)
  }
}

export default Additionality
